(function(window, document){
  'use strict';

  var PS = window.PS || (window.PS = {});
  var DAY_MS = 24 * 60 * 60 * 1000;
  var SESSION_KEY = 'ps_exit_intent_session_v1';
  var LOCAL_KEY = 'ps_exit_intent_local_v1';
  var CART_CACHE_MS = 5000;
  var CART_REFRESH_DEBOUNCE_MS = 600;

  var OFFER_REGISTRY = {
    'cart-save': {
      id: 'cart-save',
      page_type: 'cart',
      dismiss_cooldown_ms: 7 * DAY_MS,
      success_cooldown_ms: 30 * DAY_MS,
      shown_cooldown_ms: 12 * 60 * 60 * 1000,
      desktop_min_dwell_ms: 8000,
      mobile_min_dwell_ms: 10000
    },
    'save-color': {
      id: 'save-color',
      page_type: 'site',
      dismiss_cooldown_ms: 7 * DAY_MS,
      success_cooldown_ms: 3650 * DAY_MS,
      shown_cooldown_ms: 24 * 60 * 60 * 1000,
      desktop_min_dwell_ms: 8000,
      mobile_min_dwell_ms: 10000
    }
  };

  var TRIGGER_SETTINGS = {
    engagement_scroll_px: 150,
    desktop_top_zone_px: 120,
    desktop_top_zone_recent_ms: 250,
    desktop_upward_window_ms: 300,
    mobile_scrollable_ratio: 1.4,
    mobile_prior_down_px: 420,
    mobile_prior_down_pct: 0.45,
    mobile_fast_up_delta_px: 260,
    mobile_fast_up_window_ms: 320,
    mobile_top_zone_pct: 0.18,
    mobile_min_reverse_velocity: 0.45,
    inactivity_ms: 50000,
    inactivity_poll_ms: 4000,
    inactivity_retry_ms: 120000
  };

  var CONFIDENCE_SETTINGS = {
    base: {
      desktop_top_exit: 0.95,
      mobile_fast_upscroll: 0.68,
      inactivity: 0.52
    },
    threshold: {
      desktop_top_exit: 0.62,
      mobile_fast_upscroll: 0.66,
      inactivity: 0.5
    },
    desktop_penalty_scale: 0.35,
    penalties: {
      active_search: 0.22,
      predictive_search: 0.2,
      facets_interaction: 0.18,
      option_change: 0.15,
      recent_add_to_cart: 0.2,
      weak_mobile_reversal: 0.1
    },
    freshness_ms: {
      active_search: 12000,
      predictive_search: 12000,
      facets_interaction: 12000,
      option_change: 12000,
      recent_add_to_cart: 15000
    }
  };

  var cartCache = null;
  var cartCacheAt = 0;
  var cartRefreshTimer = 0;

  function q(sel, ctx){ return (ctx || document).querySelector(sel); }
  function trim(val){ return String(val == null ? '' : val).replace(/^\s+|\s+$/g, ''); }
  function lower(val){ return trim(val).toLowerCase(); }
  function hasValue(val){ return trim(val) !== ''; }
  function now(){ return new Date().getTime(); }

  function onReady(cb){
    if (!cb) return;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cb);
    else cb();
  }

  function parseJson(raw){
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (_e) { return null; }
  }

  function readStorage(storage, key){
    var raw = '';
    var parsed = null;
    if (!storage || !key) return null;
    try { raw = storage.getItem(key); } catch (_e) { raw = ''; }
    parsed = parseJson(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  }

  function writeStorage(storage, key, value){
    if (!storage || !key || !value || typeof value !== 'object') return;
    try { storage.setItem(key, JSON.stringify(value)); } catch (_e) {}
  }

  function cloneProperties(properties){
    var out = {};
    var key = '';
    if (!properties || typeof properties !== 'object') return out;
    for (key in properties) {
      if (!properties.hasOwnProperty(key)) continue;
      out[key] = properties[key];
    }
    return out;
  }

  function sortObjectKeys(obj){
    var keys = [];
    var key = '';
    var i = 0;
    var out = {};
    if (!obj || typeof obj !== 'object') return out;
    for (key in obj) {
      if (obj.hasOwnProperty(key)) keys.push(key);
    }
    keys.sort();
    for (i = 0; i < keys.length; i++) out[keys[i]] = obj[keys[i]];
    return out;
  }

  function matchesSelector(el, selector){
    var fn = null;
    var nodes = null;
    var i = 0;
    if (!el || el.nodeType !== 1 || !selector) return false;
    fn = el.matches || el.matchesSelector || el.msMatchesSelector || el.webkitMatchesSelector || el.mozMatchesSelector;
    if (fn) {
      try { return !!fn.call(el, selector); } catch (_e) {}
    }
    nodes = (el.document || el.ownerDocument).querySelectorAll(selector);
    for (i = 0; i < nodes.length; i++) {
      if (nodes[i] === el) return true;
    }
    return false;
  }

  function closestElement(el, selector){
    var current = el;
    while (current && current.nodeType === 1) {
      if (matchesSelector(current, selector)) return current;
      current = current.parentNode;
    }
    return null;
  }

  function pickValue(){
    var i = 0;
    for (i = 0; i < arguments.length; i++) {
      if (hasValue(arguments[i])) return trim(arguments[i]);
    }
    return '';
  }

  function slugify(value){
    var out = lower(value);
    if (!out) return '';
    out = out.replace(/[^a-z0-9]+/g, '-');
    out = out.replace(/^-+/, '').replace(/-+$/, '');
    return out;
  }

  function parsePathParts(path){
    var rawPath = String(path || '');
    var raw = [];
    var parts = [];
    var i = 0;
    rawPath = rawPath.split('?')[0];
    rawPath = rawPath.split('#')[0];
    raw = rawPath.split('/');
    for (i = 0; i < raw.length; i++) {
      if (!raw[i]) continue;
      parts.push(lower(raw[i]));
    }
    return parts;
  }

  function parseColorPathPart(path, index){
    var parts = parsePathParts(path);
    if (parts[0] !== 'colors') return '';
    if (parts.length > index) return parts[index];
    return '';
  }

  function normalizeCart(cart){
    var out = {
      token: '',
      item_count: 0,
      total_price: 0,
      currency: 'USD',
      items: []
    };
    var i = 0;
    var item = null;
    var normalizedItem = null;

    if (!cart || typeof cart !== 'object') return out;
    out.token = trim(cart.token);
    out.item_count = parseInt(cart.item_count, 10) || 0;
    out.total_price = parseInt(cart.total_price, 10) || 0;
    out.currency = trim(cart.currency) || 'USD';

    if (cart.items && cart.items.length) {
      for (i = 0; i < cart.items.length; i++) {
        item = cart.items[i];
        if (!item || typeof item !== 'object') continue;
        normalizedItem = {
          id: parseInt(item.id || item.variant_id, 10) || 0,
          variant_id: parseInt(item.variant_id || item.id, 10) || 0,
          quantity: parseInt(item.quantity, 10) || 0,
          selling_plan: item.selling_plan != null ? String(item.selling_plan) : '',
          properties: cloneProperties(item.properties)
        };
        if (!normalizedItem.id && !normalizedItem.variant_id) continue;
        out.items.push(normalizedItem);
      }
    }

    if (!out.item_count) {
      for (i = 0; i < out.items.length; i++) out.item_count += out.items[i].quantity || 0;
    }
    return out;
  }

  function buildCartSignature(cart){
    var items = cart && cart.items ? cart.items : [];
    var parts = [];
    var i = 0;
    var item = null;
    var props = null;
    var propText = '';

    if (!items.length) return 'empty';

    for (i = 0; i < items.length; i++) {
      item = items[i];
      props = sortObjectKeys(item && item.properties ? item.properties : {});
      propText = JSON.stringify(props);
      parts.push([
        String(item.id || item.variant_id || ''),
        String(item.quantity || 0),
        String(item.selling_plan || ''),
        propText
      ].join('~'));
    }
    parts.sort();
    return parts.join('|');
  }

  function getCartJsUrl(){
    if (window.routes && window.routes.cart_url) return String(window.routes.cart_url).replace(/\/+$/, '') + '.js';
    return '/cart.js';
  }

  function fetchCart(cb, force){
    var xhr = null;
    var currentTime = now();

    if (!force && cartCache && currentTime - cartCacheAt < CART_CACHE_MS) {
      cb(null, cartCache);
      return;
    }

    xhr = new XMLHttpRequest();
    xhr.open('GET', getCartJsUrl(), true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.timeout = 15000;
    xhr.onreadystatechange = function(){
      var parsed = null;
      if (xhr.readyState !== 4) return;
      if (!(xhr.status >= 200 && xhr.status < 300)) {
        cb(new Error('cart_fetch_failed'), null);
        return;
      }
      parsed = parseJson(xhr.responseText || '');
      cartCache = normalizeCart(parsed || {});
      cartCacheAt = now();
      cb(null, cartCache);
    };
    xhr.onerror = function(){ cb(new Error('cart_fetch_failed'), null); };
    xhr.ontimeout = function(){ cb(new Error('cart_fetch_timeout'), null); };
    xhr.send(null);
  }

  function scheduleCartRefresh(){
    if (cartRefreshTimer) {
      try { window.clearTimeout(cartRefreshTimer); } catch (_e) {}
      cartRefreshTimer = 0;
    }
    cartRefreshTimer = window.setTimeout(function(){
      cartRefreshTimer = 0;
      fetchCart(function(){}, true);
    }, CART_REFRESH_DEBOUNCE_MS);
  }

  function normalizeSessionState(raw){
    var out = { offers: {} };
    var legacyVariants = null;
    var offerId = '';
    var legacy = null;
    var sessionOffer = null;

    if (raw && typeof raw === 'object') {
      if (raw.offers && typeof raw.offers === 'object') out.offers = raw.offers;
      legacyVariants = raw.variants && typeof raw.variants === 'object' ? raw.variants : null;
      if (legacyVariants) {
        for (offerId in legacyVariants) {
          if (!legacyVariants.hasOwnProperty(offerId)) continue;
          legacy = legacyVariants[offerId];
          if (!legacy || typeof legacy !== 'object') continue;
          sessionOffer = out.offers[offerId] = out.offers[offerId] || { manual_opened: false, signatures: {} };
          if (legacy.manual_opened === true) sessionOffer.manual_opened = true;
          if (legacy.seen || legacy.dismissed || hasValue(legacy.success_cart_sig)) {
            sessionOffer.signatures['*'] = sessionOffer.signatures['*'] || { seen: false, dismissed: false, success: false, last_trigger_at: 0 };
            if (legacy.seen) sessionOffer.signatures['*'].seen = true;
            if (legacy.dismissed) sessionOffer.signatures['*'].dismissed = true;
            if (hasValue(legacy.success_cart_sig)) sessionOffer.signatures['*'].success = true;
          }
        }
      }
    }
    return out;
  }

  function normalizeLocalState(raw){
    var out = { dismiss: {}, success: {}, shown: {} };
    var offerId = '';
    var value = null;

    if (raw && typeof raw === 'object') {
      if (raw.dismiss && typeof raw.dismiss === 'object') out.dismiss = raw.dismiss;
      if (raw.success && typeof raw.success === 'object') out.success = raw.success;
      if (raw.shown && typeof raw.shown === 'object') out.shown = raw.shown;
    }

    for (offerId in out.dismiss) {
      if (!out.dismiss.hasOwnProperty(offerId)) continue;
      value = out.dismiss[offerId];
      if (typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(value))) {
        out.dismiss[offerId] = { '*': parseInt(value, 10) || 0 };
      }
    }

    for (offerId in out.success) {
      if (!out.success.hasOwnProperty(offerId)) continue;
      value = out.success[offerId];
      if (value && typeof value === 'object' && value.ts && !value.hasOwnProperty('*') && !value.hasOwnProperty('sigs')) {
        out.success[offerId] = {
          '*': {
            ts: parseInt(value.ts, 10) || 0,
            cart_sig: trim(value.cart_sig),
            cart_token: trim(value.cart_token),
            color_sig: trim(value.color_sig)
          }
        };
      }
    }

    return out;
  }

  function readSessionState(){
    var raw = readStorage(window.sessionStorage, SESSION_KEY);
    return normalizeSessionState(raw);
  }

  function writeSessionState(state){
    writeStorage(window.sessionStorage, SESSION_KEY, normalizeSessionState(state));
  }

  function readLocalState(){
    var raw = readStorage(window.localStorage, LOCAL_KEY);
    return normalizeLocalState(raw);
  }

  function writeLocalState(state){
    writeStorage(window.localStorage, LOCAL_KEY, normalizeLocalState(state));
  }

  function getOfferSession(state, offerId){
    var offers = null;
    var offer = null;
    if (!state || !offerId) return null;
    offers = state.offers = state.offers || {};
    offer = offers[offerId] = offers[offerId] || { manual_opened: false, signatures: {} };
    offer.signatures = offer.signatures || {};
    return offer;
  }

  function getSignatureSession(offerSession, signature){
    var signatures = null;
    if (!offerSession || !signature) return null;
    signatures = offerSession.signatures = offerSession.signatures || {};
    signatures[signature] = signatures[signature] || {
      seen: false,
      dismissed: false,
      success: false,
      last_trigger_at: 0
    };
    return signatures[signature];
  }

  function ensureSignatureMap(mapRoot, offerId){
    var map = null;
    if (!mapRoot || !offerId) return null;
    map = mapRoot[offerId];
    if (!map || typeof map !== 'object') {
      mapRoot[offerId] = {};
      map = mapRoot[offerId];
    }
    return map;
  }

  function isHoverFinePointer(){
    var canHover = false;
    var finePointer = false;
    try {
      canHover = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);
      finePointer = !!(window.matchMedia && window.matchMedia('(pointer: fine)').matches);
      return canHover && finePointer;
    } catch (_e) {
      return false;
    }
  }

  function getDeviceType(){
    return isHoverFinePointer() ? 'desktop' : 'mobile';
  }

  function isCartPage(){
    var path = lower(window.location && window.location.pathname);
    if (path === '/cart' || path === '/cart/') return true;
    if (document.body && /\btemplate-cart\b/.test(document.body.className || '')) return true;
    return false;
  }

  function getCurrentPageType(){
    var path = lower(window.location && window.location.pathname);
    var bodyClass = lower(document.body && document.body.className);
    var match = null;

    if (isCartPage()) return 'cart';
    if (!path || path === '/') return 'index';
    if (/^\/products\//.test(path)) return 'product';
    if (/^\/collections\//.test(path)) return 'collection';
    if (/^\/pages\//.test(path)) return 'page';
    if (/^\/search(\/|$)/.test(path)) return 'search';
    if (/^\/blogs\//.test(path)) return 'blog';

    if (hasValue(bodyClass)) {
      match = bodyClass.match(/\btemplate-([a-z0-9_-]+)/);
      if (match && hasValue(match[1])) return match[1];
    }
    return 'site';
  }

  function isOtherOverlayOpen(){
    var bodyClass = '';

    if (PS.SaveCart && typeof PS.SaveCart.isModalOpen === 'function') {
      try {
        if (PS.SaveCart.isModalOpen()) return true;
      } catch (_e) {}
    }
    if (PS.SaveColor && typeof PS.SaveColor.isModalOpen === 'function') {
      try {
        if (PS.SaveColor.isModalOpen()) return true;
      } catch (_e2) {}
    }
    if (q('#ps-modal[aria-hidden="false"]')) return true;
    if (q('[data-ps-save-cart-restore-modal][aria-hidden="false"]')) return true;
    if (q('cart-drawer.active, cart-drawer[open], .cart-drawer.active')) return true;
    if (q('details-modal[open], modal-dialog[open], .details-modal[open]')) return true;
    if (q('.cart-notification.active, .cart-notification[open]')) return true;
    bodyClass = document.body ? document.body.className || '' : '';
    if (/\boverflow-hidden\b/.test(bodyClass)) return true;
    if (/\boverflow-hidden-mobile\b/.test(bodyClass)) return true;
    if (/\boverflow-hidden-tablet\b/.test(bodyClass)) return true;
    return false;
  }

  function getSaveCartState(){
    if (!PS.SaveCart || typeof PS.SaveCart.getState !== 'function') return null;
    try { return PS.SaveCart.getState(); } catch (_e) { return null; }
  }

  function getSaveColorState(){
    if (!PS.SaveColor || typeof PS.SaveColor.getState !== 'function') return null;
    try { return PS.SaveColor.getState(); } catch (_e) { return null; }
  }

  function hasSaveColorContext(){
    if (!PS.SaveColor || typeof PS.SaveColor.hasContext !== 'function') return false;
    try { return !!PS.SaveColor.hasContext(); } catch (_e) { return false; }
  }

  function isSaveCartAlreadyComplete(saveCartState){
    var root = saveCartState && saveCartState.root ? saveCartState.root : null;
    if (!root) return false;
    if (root.getAttribute('data-ps-save-cart-complete') === 'true') return true;
    if (saveCartState && saveCartState.saved === true) return true;
    return false;
  }

  function readCc(){
    try {
      if (PS && PS.cc && typeof PS.cc.read === 'function') return PS.cc.read() || {};
    } catch (_e) {}
    return {};
  }

  function buildColorSnapshot(){
    var colorState = getSaveColorState();
    var context = colorState && colorState.context && typeof colorState.context === 'object' ? colorState.context : {};
    var cc = readCc();
    var path = String(window.location && window.location.pathname ? window.location.pathname : '');
    var makeSlug = lower(pickValue(context.make_slug, cc.make_slug, parseColorPathPart(path, 1), slugify(context.make), slugify(cc.make)));
    var colorSlug = lower(pickValue(context.color_slug, cc.color_slug, parseColorPathPart(path, 2), slugify(context.color_name), slugify(cc.color)));
    var productSlug = lower(pickValue(context.product_slug, parseColorPathPart(path, 3)));
    var surface = lower(pickValue(colorState && colorState.surface, context.source_page_type, 'site'));
    var pathIsColor = parseColorPathPart(path, 0) === 'colors';

    return {
      make: pickValue(context.make, cc.make),
      year: pickValue(context.year, cc.year),
      model: pickValue(context.model, cc.model),
      candidate_color: pickValue(context.color_name, cc.color),
      candidate_code: pickValue(context.color_code, cc.code),
      source_page_url: String(window.location && window.location.href ? window.location.href : ''),
      make_slug: makeSlug,
      color_slug: colorSlug,
      product_slug: productSlug,
      surface: surface,
      path_is_color: pathIsColor,
      has_context: hasSaveColorContext(),
      relevant_surface: pathIsColor || surface === 'color_hub' || surface === 'color_page'
    };
  }

  function buildColorSignature(colorSnapshot){
    var makeSlug = lower(colorSnapshot && colorSnapshot.make_slug);
    var colorSlug = lower(colorSnapshot && colorSnapshot.color_slug);
    var productOrSurface = lower(pickValue(colorSnapshot && colorSnapshot.product_slug, colorSnapshot && colorSnapshot.surface, 'site'));
    if (!makeSlug || !colorSlug) return '';
    return [makeSlug, colorSlug, productOrSurface].join('|');
  }

  function createOfferLookup(activeOfferIds){
    var out = {};
    var i = 0;
    var id = '';
    if (!activeOfferIds || !activeOfferIds.length) return out;
    for (i = 0; i < activeOfferIds.length; i++) {
      id = trim(activeOfferIds[i]);
      if (!id || !OFFER_REGISTRY.hasOwnProperty(id)) continue;
      out[id] = true;
    }
    return out;
  }

  function parseActiveVariantIds(){
    var config = window.paintscratchTheme && window.paintscratchTheme.psExitIntent ? window.paintscratchTheme.psExitIntent : {};
    var value = config.activeVariants;
    var out = [];
    var i = 0;
    var item = '';

    if (Object.prototype.toString.call(value) === '[object Array]') {
      for (i = 0; i < value.length; i++) {
        item = trim(value[i]);
        if (!item) continue;
        out.push(item);
      }
      return out;
    }
    if (typeof value === 'string') {
      value = value.split(',');
      for (i = 0; i < value.length; i++) {
        item = trim(value[i]);
        if (!item) continue;
        out.push(item);
      }
      return out;
    }
    return ['cart-save'];
  }

  function trackEvent(name, payload){
    var data = {};
    var key = '';
    if (!name) return;
    if (payload && typeof payload === 'object') {
      for (key in payload) {
        if (!payload.hasOwnProperty(key)) continue;
        data[key] = payload[key];
      }
    }
    data.event = name;
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(data);
    } catch (_e) {}
  }

  function isMeaningfullyScrollable(){
    var docEl = document.documentElement;
    var body = document.body;
    var viewport = window.innerHeight || (docEl && docEl.clientHeight) || 0;
    var totalHeight = Math.max(docEl ? docEl.scrollHeight : 0, body ? body.scrollHeight : 0);
    if (!viewport || !totalHeight) return false;
    return totalHeight >= viewport * TRIGGER_SETTINGS.mobile_scrollable_ratio;
  }

  function createRescueManager(activeOfferIds){
    var state = {
      active_offers: createOfferLookup(activeOfferIds),
      started_at: now(),
      checkout_started: false,
      attempt_in_flight: false,
      last_attempt_at: 0,
      last_eligibility_key: '',
      last_eligibility_at: 0,
      last_cart: null,
      last_cart_sig: 'empty',
      last_open: {},
      behavior: {
        search_active_at: 0,
        predictive_search_at: 0,
        facets_interaction_at: 0,
        option_change_at: 0,
        recent_add_to_cart_at: 0
      },
      engagement: {
        scrolled_150: false,
        quantity_change: false,
        remove_item: false,
        notes_or_discount_or_shipping: false,
        mouse_presence_3s: false,
        search_active: false,
        predictive_search: false,
        facets_interaction: false,
        option_change: false,
        recent_add_to_cart: false
      },
      mouse_move_count: 0,
      first_mouse_move_seen: false,
      mouse_presence_started_at: 0,
      prev_mouse_y: 0,
      prev_mouse_at: 0,
      last_mouse_y: 0,
      last_mouse_at: 0,
      last_top_zone_at: 0,
      first_scroll_seen: false,
      last_scroll_y: Math.max(window.pageYOffset || 0, 0),
      last_scroll_at: now(),
      max_scroll_y: Math.max(window.pageYOffset || 0, 0),
      mobile_up_start_y: 0,
      mobile_up_start_at: 0,
      latest_mobile_signal: null,
      activity_last_at: now(),
      inactivity_timer: 0,
      last_inactivity_attempt_at: 0,
      pubsub_unsubscribers: []
    };

    function getEngagementSignals(context){
      var currentTime = now();
      var signals = [];
      if (state.engagement.scrolled_150) signals.push('scroll_150');
      if (state.engagement.quantity_change) signals.push('quantity_change');
      if (state.engagement.remove_item) signals.push('remove_item');
      if (state.engagement.notes_or_discount_or_shipping) signals.push('notes_discount_shipping');
      if (context.device_type === 'desktop' && state.engagement.mouse_presence_3s) signals.push('mouse_presence_3s');
      if (currentTime - state.behavior.search_active_at < CONFIDENCE_SETTINGS.freshness_ms.active_search) signals.push('active_search');
      if (currentTime - state.behavior.predictive_search_at < CONFIDENCE_SETTINGS.freshness_ms.predictive_search) signals.push('predictive_search');
      if (currentTime - state.behavior.facets_interaction_at < CONFIDENCE_SETTINGS.freshness_ms.facets_interaction) signals.push('facets_interaction');
      if (currentTime - state.behavior.option_change_at < CONFIDENCE_SETTINGS.freshness_ms.option_change) signals.push('option_change');
      if (currentTime - state.behavior.recent_add_to_cart_at < CONFIDENCE_SETTINGS.freshness_ms.recent_add_to_cart) signals.push('recent_add_to_cart');
      return signals;
    }

    function buildEventPayload(context, extra){
      var payload = {
        offer_id: context.offer_id || '',
        variant_id: context.offer_id || '',
        offer_type: context.offer_id || '',
        page_type: context.page_type || '',
        rescue_surface: context.surface || '',
        page_path: context.page_path || '',
        device_type: context.device_type || '',
        trigger_type: context.trigger_type || '',
        signal_strength: context.signal_strength || '',
        dwell_ms: context.dwell_ms,
        engagement_signals: context.engagement_signals || '',
        cart_value: context.cart_value,
        line_item_count: context.line_item_count,
        cart_hash_or_token: context.cart_hash_or_token || '',
        cart_signature: context.cart_signature || '',
        cart_state: context.cart_state || '',
        color_signature: context.color_signature || '',
        color_has_context: context.color_has_context ? '1' : '0',
        is_color_relevant_surface: context.is_color_relevant_surface ? '1' : '0',
        confidence_score: context.confidence_score,
        confidence_threshold: context.confidence_threshold,
        confidence_reasons: context.confidence_reasons || '',
        suppression_reason: context.suppression_reason || '',
        winner_reason: context.winner_reason || '',
        eligible: context.eligible ? '1' : '0',
        active_variants: context.active_variants || ''
      };
      var details = extra && typeof extra === 'object' ? extra : {};
      var key = '';
      for (key in details) {
        if (!details.hasOwnProperty(key)) continue;
        payload[key] = details[key];
      }
      return payload;
    }

    function markBehavior(name){
      if (!name || !state.behavior.hasOwnProperty(name)) return;
      state.behavior[name] = now();
      state.engagement[name] = true;
    }

    function markActivity(){
      state.activity_last_at = now();
    }

    function isSearchInputElement(el){
      if (!el || el.nodeType !== 1) return false;
      if (matchesSelector(el, 'input[name="q"], input[type="search"]')) return true;
      if (closestElement(el, 'main-search, predictive-search, form[action*="/search"]')) return true;
      return false;
    }

    function isSearchTaskActive(){
      var currentTime = now();
      var active = document.activeElement;
      if (currentTime - state.behavior.search_active_at < CONFIDENCE_SETTINGS.freshness_ms.active_search) return true;
      if (isSearchInputElement(active) && hasValue(active.value)) return true;
      return false;
    }

    function isPredictiveSearchActive(){
      var currentTime = now();
      var active = document.activeElement;
      if (q('predictive-search[open], predictive-search[loading]')) return true;
      if (currentTime - state.behavior.predictive_search_at < CONFIDENCE_SETTINGS.freshness_ms.predictive_search) return true;
      if (closestElement(active, 'predictive-search')) return true;
      return false;
    }

    function getOfferOpener(offerId){
      if (offerId === 'save-color') return PS.SaveColor && PS.SaveColor.open;
      if (offerId === 'cart-save') return PS.SaveCart && PS.SaveCart.open;
      return null;
    }

    function hasDismissCooldown(localState, offerId, signature, currentTime){
      var offer = OFFER_REGISTRY[offerId];
      var offerMap = ensureSignatureMap(localState.dismiss || (localState.dismiss = {}), offerId);
      var ts = 0;
      if (!offer || !offerMap) return false;
      ts = parseInt(offerMap[signature], 10) || parseInt(offerMap['*'], 10) || 0;
      if (!ts) return false;
      return currentTime - ts < offer.dismiss_cooldown_ms;
    }

    function hasShownCooldown(localState, offerId, signature, currentTime){
      var offer = OFFER_REGISTRY[offerId];
      var offerMap = ensureSignatureMap(localState.shown || (localState.shown = {}), offerId);
      var ts = 0;
      if (!offer || !offerMap) return false;
      ts = parseInt(offerMap[signature], 10) || parseInt(offerMap['*'], 10) || 0;
      if (!ts) return false;
      return currentTime - ts < offer.shown_cooldown_ms;
    }

    function hasSuccessCooldown(localState, offerId, signature, currentTime){
      var offer = OFFER_REGISTRY[offerId];
      var offerMap = ensureSignatureMap(localState.success || (localState.success = {}), offerId);
      var record = offerMap[signature] || offerMap['*'];
      var ts = 0;
      if (!offer || !record || typeof record !== 'object') return false;
      ts = parseInt(record.ts, 10) || 0;
      if (!ts) return false;
      return currentTime - ts < offer.success_cooldown_ms;
    }

    function writeShown(offerId, signature){
      var sessionState = readSessionState();
      var offerSession = getOfferSession(sessionState, offerId);
      var signatureSession = getSignatureSession(offerSession, signature);
      var localState = readLocalState();
      var localShown = ensureSignatureMap(localState.shown || (localState.shown = {}), offerId);

      signatureSession.seen = true;
      signatureSession.last_trigger_at = now();
      localShown[signature] = now();
      writeSessionState(sessionState);
      writeLocalState(localState);
    }

    function writeDismissed(offerId, signature){
      var sessionState = readSessionState();
      var offerSession = getOfferSession(sessionState, offerId);
      var signatureSession = getSignatureSession(offerSession, signature);
      var localState = readLocalState();
      var localDismiss = ensureSignatureMap(localState.dismiss || (localState.dismiss = {}), offerId);

      signatureSession.dismissed = true;
      localDismiss[signature] = now();
      writeSessionState(sessionState);
      writeLocalState(localState);
    }

    function writeSuccess(offerId, signature, cartToken){
      var sessionState = readSessionState();
      var offerSession = getOfferSession(sessionState, offerId);
      var signatureSession = getSignatureSession(offerSession, signature);
      var localState = readLocalState();
      var localSuccess = ensureSignatureMap(localState.success || (localState.success = {}), offerId);

      signatureSession.success = true;
      localSuccess[signature] = {
        ts: now(),
        cart_sig: offerId === 'cart-save' ? signature : '',
        color_sig: offerId === 'save-color' ? signature : '',
        cart_token: trim(cartToken)
      };
      writeSessionState(sessionState);
      writeLocalState(localState);
    }

    function markManualOpened(offerId){
      var sessionState = readSessionState();
      var offerSession = getOfferSession(sessionState, offerId);
      offerSession.manual_opened = true;
      writeSessionState(sessionState);
    }

    function buildContext(triggerType, triggerMeta, cart){
      var colorSnapshot = buildColorSnapshot();
      var colorSignature = buildColorSignature(colorSnapshot);
      var cartSig = buildCartSignature(cart);
      var cartToken = trim(cart && cart.token);
      var deviceType = getDeviceType();
      var pageType = getCurrentPageType();
      var defaultSurface = isCartPage() ? 'cart' : pageType;

      state.last_cart = cart;
      state.last_cart_sig = cartSig;

      return {
        trigger_type: triggerType,
        trigger_meta: triggerMeta || {},
        cart_signature: cartSig,
        cart_token: cartToken,
        cart_item_count: parseInt(cart && cart.item_count, 10) || 0,
        cart_value: parseInt(cart && cart.total_price, 10) || 0,
        cart_hash_or_token: cartToken || cartSig,
        cart_state: (parseInt(cart && cart.item_count, 10) || 0) > 0 ? 'has_items' : 'empty',
        is_cart_page: isCartPage(),
        device_type: deviceType,
        dwell_ms: now() - state.started_at,
        page_path: String(window.location && window.location.pathname ? window.location.pathname : ''),
        source_page_url: colorSnapshot.source_page_url,
        active_variants: Object.keys ? Object.keys(state.active_offers).join(',') : '',
        color_has_context: colorSnapshot.has_context,
        color_signature: colorSignature,
        color_surface: colorSnapshot.surface,
        make: colorSnapshot.make,
        year: colorSnapshot.year,
        model: colorSnapshot.model,
        candidate_color: colorSnapshot.candidate_color,
        candidate_code: colorSnapshot.candidate_code,
        is_color_relevant_surface: colorSnapshot.relevant_surface,
        overlay_open: isOtherOverlayOpen(),
        mobile_scrollable: isMeaningfullyScrollable(),
        offer_id: '',
        page_type: pageType,
        surface: colorSnapshot.surface || defaultSurface,
        winner_reason: '',
        suppression_reason: '',
        confidence_reasons: '',
        confidence_score: 0,
        confidence_threshold: 0,
        signal_strength: '',
        eligible: false,
        line_item_count: parseInt(cart && cart.item_count, 10) || 0,
        engagement_signals: ''
      };
    }

    function chooseWinner(context){
      if (state.active_offers['cart-save'] && context.cart_item_count > 0) {
        return {
          offer_id: 'cart-save',
          winner_reason: context.is_cart_page ? 'cart_page_with_items' : 'cart_has_items_sitewide'
        };
      }
      if (state.active_offers['save-color'] && context.cart_item_count < 1 && context.color_has_context) {
        return { offer_id: 'save-color', winner_reason: 'empty_cart_with_color_context' };
      }
      return null;
    }

    function evaluateSuppression(context, offerId, signature){
      var currentTime = now();
      var sessionState = readSessionState();
      var localState = readLocalState();
      var offerSession = getOfferSession(sessionState, offerId);
      var signatureSession = getSignatureSession(offerSession, signature);

      if (!offerSession || !signatureSession) return 'suppression_state_error';
      if (context.checkout_started) return 'checkout_started';
      if (offerSession.manual_opened) return 'manual_opened';
      if (signatureSession.success) return 'session_success';
      if (signatureSession.dismissed) return 'session_dismissed';
      if (signatureSession.seen) return 'session_seen';
      if (hasDismissCooldown(localState, offerId, signature, currentTime)) return 'dismiss_cooldown';
      if (hasSuccessCooldown(localState, offerId, signature, currentTime)) return 'success_cooldown';
      if (hasShownCooldown(localState, offerId, signature, currentTime)) return 'shown_cooldown';
      return '';
    }

    function evaluateConfidence(context){
      var triggerType = context.trigger_type;
      var base = CONFIDENCE_SETTINGS.base[triggerType];
      var threshold = CONFIDENCE_SETTINGS.threshold[triggerType];
      var score = typeof base === 'number' ? base : 0.5;
      var scale = triggerType === 'desktop_top_exit' ? CONFIDENCE_SETTINGS.desktop_penalty_scale : 1;
      var reasons = [];

      if (isSearchTaskActive()) {
        score -= CONFIDENCE_SETTINGS.penalties.active_search * scale;
        reasons.push('active_search');
      }
      if (isPredictiveSearchActive()) {
        score -= CONFIDENCE_SETTINGS.penalties.predictive_search * scale;
        reasons.push('predictive_search');
      }
      if (now() - state.behavior.facets_interaction_at < CONFIDENCE_SETTINGS.freshness_ms.facets_interaction) {
        score -= CONFIDENCE_SETTINGS.penalties.facets_interaction * scale;
        reasons.push('facets_interaction');
      }
      if (now() - state.behavior.option_change_at < CONFIDENCE_SETTINGS.freshness_ms.option_change) {
        score -= CONFIDENCE_SETTINGS.penalties.option_change * scale;
        reasons.push('option_change');
      }
      if (now() - state.behavior.recent_add_to_cart_at < CONFIDENCE_SETTINGS.freshness_ms.recent_add_to_cart) {
        score -= CONFIDENCE_SETTINGS.penalties.recent_add_to_cart * scale;
        reasons.push('recent_add_to_cart');
      }
      if (triggerType === 'mobile_fast_upscroll') {
        if (!context.trigger_meta || (parseInt(context.trigger_meta.up_distance, 10) || 0) < TRIGGER_SETTINGS.mobile_fast_up_delta_px + 40) {
          score -= CONFIDENCE_SETTINGS.penalties.weak_mobile_reversal;
          reasons.push('weak_mobile_reversal');
        }
      }

      if (score < 0) score = 0;
      if (score > 1) score = 1;

      context.confidence_score = Math.round(score * 1000) / 1000;
      context.confidence_threshold = typeof threshold === 'number' ? threshold : 0.5;
      context.confidence_reasons = reasons.join(',');
      if (triggerType === 'desktop_top_exit') context.signal_strength = 'strong';
      else if (triggerType === 'mobile_fast_upscroll') context.signal_strength = 'medium';
      else context.signal_strength = 'weak';

      return context.confidence_score >= context.confidence_threshold;
    }

    function evaluateDecision(context){
      var winner = null;
      var opener = null;
      var signature = '';
      var minDwell = 0;
      var suppressionReason = '';
      var saveCartState = null;

      context.checkout_started = state.checkout_started;

      if (context.overlay_open) {
        context.suppression_reason = 'overlay_open';
        return null;
      }

      winner = chooseWinner(context);
      if (!winner) {
        context.suppression_reason = 'no_offer_match';
        return null;
      }

      context.offer_id = winner.offer_id;
      context.winner_reason = winner.winner_reason;
      if (winner.offer_id === 'cart-save') context.surface = context.is_cart_page ? 'cart' : (context.page_type || 'site');
      else context.surface = context.color_surface || context.page_type || 'site';

      opener = getOfferOpener(winner.offer_id);
      if (typeof opener !== 'function') {
        context.suppression_reason = 'offer_api_unavailable';
        return null;
      }

      if (winner.offer_id === 'cart-save') {
        saveCartState = getSaveCartState();
        if (isSaveCartAlreadyComplete(saveCartState)) {
          context.suppression_reason = 'save_cart_complete';
          return null;
        }
        signature = context.cart_signature;
      } else {
        signature = context.color_signature;
        if (!context.color_has_context) {
          context.suppression_reason = 'save_color_context_missing';
          return null;
        }
        if (!context.is_color_relevant_surface) {
          context.suppression_reason = 'save_color_off_color_surface';
          return null;
        }
      }

      if (!hasValue(signature)) {
        context.suppression_reason = 'signature_missing';
        return null;
      }

      minDwell = context.device_type === 'desktop' ? OFFER_REGISTRY[winner.offer_id].desktop_min_dwell_ms : OFFER_REGISTRY[winner.offer_id].mobile_min_dwell_ms;
      if (context.dwell_ms < minDwell) {
        context.suppression_reason = 'min_dwell';
        return null;
      }

      if (context.trigger_type === 'mobile_fast_upscroll' && !context.mobile_scrollable) {
        context.suppression_reason = 'mobile_not_scrollable';
        return null;
      }

      suppressionReason = evaluateSuppression(context, winner.offer_id, signature);
      if (suppressionReason) {
        context.suppression_reason = suppressionReason;
        return null;
      }

      if (!evaluateConfidence(context)) {
        context.suppression_reason = context.confidence_reasons || 'confidence_below_threshold';
        return null;
      }

      context.eligible = true;
      context.engagement_signals = getEngagementSignals(context).join(',');
      return {
        offer_id: winner.offer_id,
        signature: signature,
        opener: opener
      };
    }

    function trackEligibility(context){
      var key = [
        context.offer_id,
        context.trigger_type,
        context.cart_signature,
        context.color_signature,
        context.suppression_reason,
        context.confidence_score,
        context.confidence_reasons
      ].join('|');
      var currentTime = now();

      if (key === state.last_eligibility_key && currentTime - state.last_eligibility_at < 1500) return;
      state.last_eligibility_key = key;
      state.last_eligibility_at = currentTime;

      trackEvent('exit_intent_eligible', buildEventPayload(context, {
        trigger_type: context.trigger_type || '',
        suppression_reason: context.suppression_reason || '',
        confidence_reasons: context.confidence_reasons || ''
      }));
    }

    function presentDecision(context, decision){
      var opened = false;
      var openContext = null;

      trackEvent('exit_intent_triggered', buildEventPayload(context, {
        trigger_type: context.trigger_type
      }));

      try {
        opened = !!decision.opener({
          source: 'exit_intent',
          variant_id: decision.offer_id,
          offer_id: decision.offer_id,
          trigger_type: context.trigger_type,
          source_page_type: context.page_type,
          source_surface: context.surface,
          source_page_url: context.source_page_url,
          make: context.make,
          year: context.year,
          model: context.model,
          candidate_color: context.candidate_color,
          candidate_code: context.candidate_code,
          device_type: context.device_type,
          winner_reason: context.winner_reason,
          confidence_reasons: context.confidence_reasons,
          cart_signature: context.cart_signature,
          force: false
        });
      } catch (_e) {
        opened = false;
      }

      if (!opened) {
        context.suppression_reason = 'offer_open_failed';
        return false;
      }

      openContext = {
        offer_id: decision.offer_id,
        signature: decision.signature,
        trigger_type: context.trigger_type,
        cart_token: context.cart_token,
        cart_signature: context.cart_signature,
        color_signature: context.color_signature,
        page_type: context.page_type,
        surface: context.surface,
        device_type: context.device_type,
        engagement_signals: context.engagement_signals,
        cart_value: context.cart_value,
        line_item_count: context.line_item_count,
        cart_hash_or_token: context.cart_hash_or_token,
        confidence_score: context.confidence_score,
        confidence_threshold: context.confidence_threshold,
        confidence_reasons: context.confidence_reasons,
        signal_strength: context.signal_strength,
        winner_reason: context.winner_reason,
        is_color_relevant_surface: context.is_color_relevant_surface,
        color_has_context: context.color_has_context,
        eligible: true,
        page_path: context.page_path,
        active_variants: context.active_variants,
        submit_succeeded_for_open: false,
        opened_at: now()
      };

      state.last_open[decision.offer_id] = openContext;
      return true;
    }

    function attemptTrigger(triggerType, triggerMeta){
      if (!triggerType) return;
      if (state.checkout_started) return;
      if (state.attempt_in_flight) return;
      if (now() - state.last_attempt_at < 350) return;

      state.last_attempt_at = now();
      state.attempt_in_flight = true;
      fetchCart(function(err, cart){
        var context = null;
        var decision = null;

        state.attempt_in_flight = false;
        if (err || !cart) return;

        context = buildContext(triggerType, triggerMeta, cart);
        decision = evaluateDecision(context);
        if (!decision) {
          context.engagement_signals = getEngagementSignals(context).join(',');
          trackEligibility(context);
          return;
        }

        trackEligibility(context);
        presentDecision(context, decision);
      }, false);
    }

    function contextFromOpen(openCtx){
      return {
        offer_id: openCtx.offer_id,
        page_type: openCtx.page_type,
        surface: openCtx.surface,
        page_path: openCtx.page_path,
        device_type: openCtx.device_type,
        trigger_type: openCtx.trigger_type,
        signal_strength: openCtx.signal_strength,
        dwell_ms: now() - state.started_at,
        engagement_signals: openCtx.engagement_signals || '',
        cart_value: openCtx.cart_value,
        line_item_count: openCtx.line_item_count,
        cart_hash_or_token: openCtx.cart_hash_or_token,
        cart_signature: openCtx.cart_signature,
        cart_state: openCtx.line_item_count > 0 ? 'has_items' : 'empty',
        color_signature: openCtx.color_signature,
        color_has_context: openCtx.color_has_context,
        is_color_relevant_surface: openCtx.is_color_relevant_surface,
        confidence_score: openCtx.confidence_score,
        confidence_threshold: openCtx.confidence_threshold,
        confidence_reasons: openCtx.confidence_reasons,
        winner_reason: openCtx.winner_reason,
        eligible: true,
        active_variants: openCtx.active_variants
      };
    }

    function onOfferOpened(offerId, evt){
      var detail = evt && evt.detail ? evt.detail : {};
      var source = lower(detail.source);
      var variantId = trim(detail.variant_id) || offerId;
      var openCtx = state.last_open[variantId];
      var context = null;

      if (source === 'manual') {
        markManualOpened(offerId);
        return;
      }
      if (source !== 'exit_intent') return;
      if (!openCtx) return;

      writeShown(variantId, openCtx.signature);
      context = contextFromOpen(openCtx);
      context.trigger_type = trim(detail.trigger_type) || openCtx.trigger_type || '';
      trackEvent('exit_intent_shown', buildEventPayload(context, {
        trigger_type: context.trigger_type
      }));
    }

    function onOfferClosed(offerId, evt){
      var detail = evt && evt.detail ? evt.detail : {};
      var source = lower(detail.source);
      var variantId = trim(detail.variant_id) || offerId;
      var openCtx = state.last_open[variantId];
      var dismissReason = lower(detail.dismiss_reason);
      var dismissMethod = '';
      var context = null;

      if (source !== 'exit_intent') return;
      if (!openCtx) return;

      if (dismissReason === 'x') dismissMethod = 'x';
      else if (dismissReason === 'escape') dismissMethod = 'escape';
      else if (dismissReason === 'backdrop') dismissMethod = 'backdrop';
      else if (dismissReason === 'secondary_action') dismissMethod = 'secondary_action';

      if (dismissMethod && !openCtx.submit_succeeded_for_open) {
        writeDismissed(variantId, openCtx.signature);
        context = contextFromOpen(openCtx);
        trackEvent('exit_intent_dismissed', buildEventPayload(context, {
          dismiss_method: dismissMethod
        }));
      }

      delete state.last_open[variantId];
    }

    function onOfferSubmitStarted(offerId, evt){
      var detail = evt && evt.detail ? evt.detail : {};
      var source = lower(detail.source);
      var variantId = trim(detail.variant_id) || offerId;
      var openCtx = state.last_open[variantId];
      var context = null;
      if (source !== 'exit_intent') return;
      if (!openCtx) return;
      context = contextFromOpen(openCtx);
      trackEvent('exit_intent_submit_started', buildEventPayload(context, {}));
    }

    function onOfferSubmitSucceeded(offerId, evt){
      var detail = evt && evt.detail ? evt.detail : {};
      var source = lower(detail.source);
      var variantId = trim(detail.variant_id) || offerId;
      var openCtx = state.last_open[variantId];
      var context = null;

      if (source !== 'exit_intent') return;
      if (!openCtx) return;

      openCtx.submit_succeeded_for_open = true;

      fetchCart(function(err, cart){
        var token = '';
        if (!err && cart) {
          openCtx.cart_signature = buildCartSignature(cart);
          openCtx.line_item_count = parseInt(cart.item_count, 10) || 0;
          openCtx.cart_value = parseInt(cart.total_price, 10) || 0;
          token = trim(cart.token);
          openCtx.cart_hash_or_token = token || openCtx.cart_signature;
        }
        if (!token) token = trim(detail.cart_token) || openCtx.cart_token;
        writeSuccess(variantId, openCtx.signature, token);
        context = contextFromOpen(openCtx);
        trackEvent('exit_intent_submit_succeeded', buildEventPayload(context, {}));
      }, true);
    }

    function onOfferSubmitFailed(offerId, evt){
      var detail = evt && evt.detail ? evt.detail : {};
      var source = lower(detail.source);
      var variantId = trim(detail.variant_id) || offerId;
      var openCtx = state.last_open[variantId];
      var context = null;
      if (source !== 'exit_intent') return;
      if (!openCtx) return;
      context = contextFromOpen(openCtx);
      trackEvent('exit_intent_submit_failed', buildEventPayload(context, {}));
    }

    function handleCheckoutIntent(){ state.checkout_started = true; }

    function onDocumentClick(evt){
      var target = evt && evt.target ? evt.target : null;
      if (!target) return;

      if (closestElement(target, 'button[name="checkout"], #checkout, .additional-checkout-buttons button, .additional-checkout-buttons [role="button"], a[href*="/checkout"]')) {
        handleCheckoutIntent();
        return;
      }
      if (closestElement(target, 'cart-remove-button, [data-index][name="updates[]"], .cart-remove-button')) {
        state.engagement.remove_item = true;
        scheduleCartRefresh();
      }
      if (closestElement(target, '#Cart-note, [name="note"], [name="discount"], [data-discount], [id*="shipping"], [class*="shipping"]')) {
        state.engagement.notes_or_discount_or_shipping = true;
      }
      if (closestElement(target, 'facet-filters-form')) markBehavior('facets_interaction_at');
      if (isSearchInputElement(target) || closestElement(target, 'predictive-search')) markBehavior('search_active_at');
      if (closestElement(target, '[name="add"], button[type="submit"][name="add"], [data-add-to-cart]')) {
        markBehavior('recent_add_to_cart_at');
        scheduleCartRefresh();
      }
      markActivity();
    }

    function onDocumentChange(evt){
      var target = evt && evt.target ? evt.target : null;
      if (!target) return;

      if (matchesSelector(target, '[name="updates[]"], input.quantity__input, [data-quantity-variant-id]')) {
        state.engagement.quantity_change = true;
        scheduleCartRefresh();
      }
      if (matchesSelector(target, '#Cart-note, [name="note"], [name="discount"], [data-discount], [id*="shipping"], [class*="shipping"]')) {
        state.engagement.notes_or_discount_or_shipping = true;
      }
      if (matchesSelector(target, '[name^="options"], variant-selects select, input[name^="options"]')) markBehavior('option_change_at');
      if (closestElement(target, 'facet-filters-form')) markBehavior('facets_interaction_at');
      if (isSearchInputElement(target) || closestElement(target, 'predictive-search')) markBehavior('search_active_at');
      markActivity();
    }

    function onDocumentInput(evt){
      var target = evt && evt.target ? evt.target : null;
      if (!target) return;
      if (matchesSelector(target, '#Cart-note, [name="note"], [name="discount"], [data-discount], [id*="shipping"], [class*="shipping"]')) {
        state.engagement.notes_or_discount_or_shipping = true;
      }
      if (closestElement(target, 'facet-filters-form')) markBehavior('facets_interaction_at');
      if (isSearchInputElement(target)) markBehavior('search_active_at');
      if (closestElement(target, 'predictive-search')) markBehavior('predictive_search_at');
      markActivity();
    }

    function onDocumentFocusIn(evt){
      var target = evt && evt.target ? evt.target : null;
      if (!target) return;
      if (isSearchInputElement(target)) markBehavior('search_active_at');
      if (closestElement(target, 'predictive-search')) markBehavior('predictive_search_at');
      markActivity();
    }

    function onDocumentSubmit(evt){
      var target = evt && evt.target ? evt.target : null;
      var action = '';
      if (!target) return;
      if (matchesSelector(target, 'form#cart, form[action="/cart"], form[action="/cart/"]')) {
        handleCheckoutIntent();
        return;
      }
      action = lower(target.getAttribute('action'));
      if (action.indexOf('/cart/add') > -1) {
        markBehavior('recent_add_to_cart_at');
        scheduleCartRefresh();
      }
      if (closestElement(target, 'facet-filters-form')) markBehavior('facets_interaction_at');
      if (isSearchInputElement(target)) markBehavior('search_active_at');
      markActivity();
    }

    function onBeforeUnload(){ handleCheckoutIntent(); }

    function onMouseMove(evt){
      var currentTime = now();
      var y = evt && typeof evt.clientY === 'number' ? evt.clientY : 0;
      var insideViewport = y >= 0 && y <= ((window.innerHeight || 0) + 2);
      var gap = currentTime - state.last_mouse_at;

      if (currentTime - state.activity_last_at > 1000) markActivity();

      state.mouse_move_count += 1;
      if (!state.first_mouse_move_seen) {
        state.first_mouse_move_seen = true;
        state.last_mouse_y = y;
        state.last_mouse_at = currentTime;
        state.mouse_presence_started_at = currentTime;
        return;
      }

      state.prev_mouse_y = state.last_mouse_y;
      state.prev_mouse_at = state.last_mouse_at;
      state.last_mouse_y = y;
      state.last_mouse_at = currentTime;

      if (y >= 0 && y <= TRIGGER_SETTINGS.desktop_top_zone_px) state.last_top_zone_at = currentTime;
      if (!insideViewport) { state.mouse_presence_started_at = 0; return; }
      if (!state.mouse_presence_started_at || gap > 450) state.mouse_presence_started_at = currentTime;
      if (!state.engagement.mouse_presence_3s && currentTime - state.mouse_presence_started_at >= 3000) {
        state.engagement.mouse_presence_3s = true;
      }
    }

    function onMouseOut(evt){
      var currentTime = now();
      var related = evt ? (evt.relatedTarget || evt.toElement) : null;
      var x = evt && typeof evt.clientX === 'number' ? evt.clientX : 0;
      var y = evt && typeof evt.clientY === 'number' ? evt.clientY : 0;
      var width = window.innerWidth || (document.documentElement && document.documentElement.clientWidth) || 0;
      var upwardRecent = false;

      if (getDeviceType() !== 'desktop') return;
      if (state.checkout_started) return;
      if (!state.first_mouse_move_seen || state.mouse_move_count < 2) return;
      if (related) return;
      if (x <= 0 || x >= width) return;
      if (y > 0) return;
      if (!state.last_top_zone_at || currentTime - state.last_top_zone_at > TRIGGER_SETTINGS.desktop_top_zone_recent_ms) return;
      upwardRecent = state.prev_mouse_at > 0 &&
        currentTime - state.prev_mouse_at <= TRIGGER_SETTINGS.desktop_upward_window_ms &&
        state.last_mouse_y < state.prev_mouse_y;
      if (!upwardRecent) return;
      attemptTrigger('desktop_top_exit', {});
    }

    function onScroll(){
      var currentTime = now();
      var currentY = Math.max(window.pageYOffset || 0, 0);
      var delta = currentY - state.last_scroll_y;
      var viewport = window.innerHeight || (document.documentElement && document.documentElement.clientHeight) || 0;
      var docEl = document.documentElement;
      var body = document.body;
      var totalHeight = Math.max(docEl ? docEl.scrollHeight : 0, body ? body.scrollHeight : 0);
      var scrollable = totalHeight > viewport ? (totalHeight - viewport) : 0;
      var downThreshold = Math.max(TRIGGER_SETTINGS.mobile_prior_down_px, Math.round(scrollable * TRIGGER_SETTINGS.mobile_prior_down_pct));
      var topZoneLimit = Math.round((scrollable || 0) * TRIGGER_SETTINGS.mobile_top_zone_pct);
      var inTopZone = currentY <= topZoneLimit;
      var upDistance = 0;
      var upDuration = 0;
      var velocity = 0;

      markActivity();

      if (!state.first_scroll_seen) {
        state.first_scroll_seen = true;
        state.last_scroll_y = currentY;
        state.last_scroll_at = currentTime;
        state.max_scroll_y = currentY;
        return;
      }

      if (currentY >= TRIGGER_SETTINGS.engagement_scroll_px) state.engagement.scrolled_150 = true;
      if (currentY > state.max_scroll_y) state.max_scroll_y = currentY;

      if (getDeviceType() === 'mobile' && !state.checkout_started) {
        if (delta < -18) {
          if (!state.mobile_up_start_at || currentTime - state.mobile_up_start_at > TRIGGER_SETTINGS.mobile_fast_up_window_ms || state.last_scroll_y <= currentY) {
            state.mobile_up_start_at = currentTime;
            state.mobile_up_start_y = state.last_scroll_y;
          }
          upDistance = state.mobile_up_start_y - currentY;
          upDuration = currentTime - state.mobile_up_start_at;
          velocity = upDuration > 0 ? (upDistance / upDuration) : 0;
          if (state.max_scroll_y >= downThreshold &&
              upDistance >= TRIGGER_SETTINGS.mobile_fast_up_delta_px &&
              upDuration <= TRIGGER_SETTINGS.mobile_fast_up_window_ms &&
              inTopZone &&
              velocity >= TRIGGER_SETTINGS.mobile_min_reverse_velocity) {
            state.latest_mobile_signal = {
              up_distance: upDistance,
              up_duration: upDuration,
              down_threshold: downThreshold,
              top_zone_limit: topZoneLimit
            };
            attemptTrigger('mobile_fast_upscroll', state.latest_mobile_signal);
          }
        } else if (delta > 0) {
          state.mobile_up_start_at = 0;
          state.mobile_up_start_y = 0;
        }
      }

      state.last_scroll_y = currentY;
      state.last_scroll_at = currentTime;
    }

    function onKeyDown(){ markActivity(); }
    function onTouchStart(){ markActivity(); }

    function bindPubSub(){
      var subFn = window.subscribe;
      var unsub = null;
      if (typeof subFn !== 'function') return;
      try {
        unsub = subFn('option-value-selection-change', function(){
          markBehavior('option_change_at');
          markActivity();
        });
        if (typeof unsub === 'function') state.pubsub_unsubscribers.push(unsub);
      } catch (_e) {}
      try {
        unsub = subFn('cart-update', function(data){
          var source = lower(data && data.source);
          if (!source || source === 'cart-items') {
            scheduleCartRefresh();
            return;
          }
          markBehavior('recent_add_to_cart_at');
          scheduleCartRefresh();
          markActivity();
        });
        if (typeof unsub === 'function') state.pubsub_unsubscribers.push(unsub);
      } catch (_e2) {}
    }

    function scheduleInactivityCheck(){
      if (state.inactivity_timer) {
        try { window.clearTimeout(state.inactivity_timer); } catch (_e) {}
        state.inactivity_timer = 0;
      }
      state.inactivity_timer = window.setTimeout(function(){
        var idleMs = now() - state.activity_last_at;
        var currentTime = now();
        if (!state.checkout_started && idleMs >= TRIGGER_SETTINGS.inactivity_ms && currentTime - state.last_inactivity_attempt_at >= TRIGGER_SETTINGS.inactivity_retry_ms) {
          state.last_inactivity_attempt_at = currentTime;
          attemptTrigger('inactivity', { idle_ms: idleMs });
        }
        scheduleInactivityCheck();
      }, TRIGGER_SETTINGS.inactivity_poll_ms);
    }

    function init(){
      if (!state.active_offers['cart-save'] && !state.active_offers['save-color']) return;

      fetchCart(function(){}, true);

      document.addEventListener('ps:save-cart:opened', function(evt){ onOfferOpened('cart-save', evt); });
      document.addEventListener('ps:save-cart:closed', function(evt){ onOfferClosed('cart-save', evt); });
      document.addEventListener('ps:save-cart:submit-started', function(evt){ onOfferSubmitStarted('cart-save', evt); });
      document.addEventListener('ps:save-cart:submit-succeeded', function(evt){ onOfferSubmitSucceeded('cart-save', evt); });
      document.addEventListener('ps:save-cart:submit-failed', function(evt){ onOfferSubmitFailed('cart-save', evt); });

      document.addEventListener('ps:save-color:opened', function(evt){ onOfferOpened('save-color', evt); });
      document.addEventListener('ps:save-color:closed', function(evt){ onOfferClosed('save-color', evt); });
      document.addEventListener('ps:save-color:submit-started', function(evt){ onOfferSubmitStarted('save-color', evt); });
      document.addEventListener('ps:save-color:submit-succeeded', function(evt){ onOfferSubmitSucceeded('save-color', evt); });
      document.addEventListener('ps:save-color:submit-failed', function(evt){ onOfferSubmitFailed('save-color', evt); });

      document.addEventListener('click', onDocumentClick, true);
      document.addEventListener('change', onDocumentChange, true);
      document.addEventListener('input', onDocumentInput, true);
      document.addEventListener('focusin', onDocumentFocusIn, true);
      document.addEventListener('submit', onDocumentSubmit, true);
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseout', onMouseOut);
      document.addEventListener('keydown', onKeyDown, true);
      document.addEventListener('touchstart', onTouchStart, true);
      window.addEventListener('scroll', onScroll, false);
      window.addEventListener('beforeunload', onBeforeUnload);

      bindPubSub();
      scheduleInactivityCheck();
    }

    return { init: init };
  }

  function init(){
    var activeOfferIds = parseActiveVariantIds();
    var manager = createRescueManager(activeOfferIds);
    if (manager && typeof manager.init === 'function') manager.init();
  }

  onReady(init);
})(window, document);
